import { NgModule, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';
import { ClipboardModule } from 'ngx-clipboard';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { environment } from 'src/environments/environment';
// #fake-start#
import { ToastModule } from './shared/toast/toast.module';
import { JwtInterceptor } from './modules/authentication/interceptors/jwt-interceptor';
import { ErrorInterceptor } from './modules/authentication/interceptors/error.interceptor';
import { AuthCallbackComponent } from './shared/auth-callback/auth-callback.component';
import { ValidateCallbackComponent } from './shared/validate-callback/validate-callback.component';
import { AuthLogoutComponent } from './shared/auth-logout/auth-logout.component';
import { Idle, IdleExpiry, SimpleExpiry } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { RouteReuseStrategy, ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router';

// #fake-end#

// function appInitializer(authService: AuthService)
// {
//   return () =>
//   {
//     return new Promise((resolve) =>
//     {
//       //@ts-ignore
//       authService.getUserByToken().subscribe().add(resolve);
//     });
//   };
// }
export class CustomReuseStrategy implements RouteReuseStrategy {

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {

    // Full final URL after redirects
    const futureUrl = future['_routerState']?.url ?? '';

    // Disable reuse ANY TIME user is on Manage API Home.
    // During route migration, support both possible entry paths.
    if (
      futureUrl === '/dentalbridge/manage-api' ||
      futureUrl === 'dentalbridge/manage-api'
    ) {
      return false;
    }

    return future.routeConfig === curr.routeConfig;
  }

  shouldDetach(): boolean { return false; }
  store(): void {}
  shouldAttach(): boolean { return false; }
  retrieve(): DetachedRouteHandle | null { return null; }
}

@NgModule({ declarations: [AppComponent, AuthCallbackComponent, ValidateCallbackComponent, AuthLogoutComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        TranslateModule.forRoot(),
        ClipboardModule,
        // #fake-start#
        // environment.isMockEnabled
        //   ? HttpClientInMemoryWebApiModule.forRoot(FakeAPIService, {
        //     passThruUnknownUrl: true,
        //     dataEncapsulation: false,
        //   })
        //   : [],
        // #fake-end#
        AppRoutingModule,
        InlineSVGModule.forRoot(),
        ToastModule], providers: [
        // TODO: make this wokring
        // {
        //   provide: APP_INITIALIZER,
        //   useFactory: appInitializer,
        //   multi: true,
        //   deps: [AuthService],
        // },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: RouteReuseStrategy, useClass: CustomReuseStrategy },
        Idle,
        { provide: IdleExpiry, useClass: SimpleExpiry },
        Keepalive,
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
    ] })
export class AppModule { }
